import styled from "styled-components"

export const Layout = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  background: ${props =>
    props.dark ? "var(--UI-Light-Gray, #f8f8f8)" : "inherit"};
`
